// Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ChainAccountValues } from './LiquidityAsset'
import { PoolDynamicOverviewCTO } from './PoolDynamicCTO'
import { PoolFlexAccountCTO } from './PoolFlexAccountCTO'
import { PoolFlexOverviewCTO } from './PoolFlexCTO'

import { PoolAccountCTO } from './PoolTermAccountCTO'
import { PoolOverviewCTO } from './PoolTermCTO'

import { EthAddr } from './SchemaTypes'
import { PoolDynamicAccountCTO, PoolLytAccountCTO, PoolLytOverviewCTO } from './sharedTypes'

export enum WSClientActions {
  POOL_OVERVIEW_DATA = 'POOL_OVERVIEW_DATA',
  POOL_ACCOUNT_DATA = 'POOL_ACCOUNT',
  CHAIN_TIMESTAMP_DELTA = 'CHAIN_TIMESTAMP_DELTA',
  ACCOUNT_BALANCES_DATA = 'ACCOUNT_BALANCES_DATA',
  CLOCK_DATA = 'CLOCK_DATA',
}

export type WSClientAction = {
  action: WSClientActions
}

export type WSClientActionPoolOverviewUpdate = WSClientAction & {
  action: WSClientActions.POOL_OVERVIEW_DATA
  poolOverviewCTO: PoolOverviewCTO | PoolFlexOverviewCTO | PoolDynamicOverviewCTO | PoolLytOverviewCTO
  poolAddr: EthAddr
}

export function wsClientActionPoolOverviewUpdate(
  poolAddr: EthAddr,
  poolOverviewCTO: PoolOverviewCTO | PoolFlexOverviewCTO | PoolDynamicOverviewCTO | PoolLytOverviewCTO
): string {
  const action: WSClientActionPoolOverviewUpdate = {
    action: WSClientActions.POOL_OVERVIEW_DATA,
    poolOverviewCTO,
    poolAddr,
  }
  return JSON.stringify(action)
}

export type WSClientActionPoolAccountUpdate = WSClientAction & {
  action: WSClientActions.POOL_ACCOUNT_DATA
  poolAccountCTO: PoolAccountCTO | PoolFlexAccountCTO | PoolDynamicAccountCTO | PoolLytAccountCTO
  poolAddr: EthAddr
}

export function wsClientActionPoolAccountUpdate(
  poolAddr: EthAddr,
  poolAccountCTO: PoolAccountCTO | PoolFlexAccountCTO | PoolDynamicAccountCTO | PoolLytAccountCTO
): string {
  const action: WSClientActionPoolAccountUpdate = {
    action: WSClientActions.POOL_ACCOUNT_DATA,
    poolAccountCTO,
    poolAddr,
  }
  return JSON.stringify(action)
}

export type WSClientActionChainTimestampDelta = WSClientAction & {
  action: WSClientActions.CHAIN_TIMESTAMP_DELTA
  chainTimestampDelta: number
}

export function wsClientActionChainTimestampDelta(chainTimestampDelta: number): string {
  const action: WSClientActionChainTimestampDelta = {
    action: WSClientActions.CHAIN_TIMESTAMP_DELTA,
    chainTimestampDelta,
  }
  return JSON.stringify(action)
}

export type WSClientActionAccountBalancesUpdate = WSClientAction & {
  action: WSClientActions.ACCOUNT_BALANCES_DATA
  accountAddr: EthAddr
  accountBalances: ChainAccountValues
}

export function wsClientActionAccountBalancesUpdate(args: {
  accountAddr: EthAddr
  accountBalances: ChainAccountValues
}): string {
  const { accountAddr, accountBalances } = args
  const action: WSClientActionAccountBalancesUpdate = {
    action: WSClientActions.ACCOUNT_BALANCES_DATA,
    accountAddr,
    accountBalances,
  }
  return JSON.stringify(action)
}

export type WSClientActionClockUpdate = WSClientAction & {
  action: WSClientActions.CLOCK_DATA
  chainTimestampDelta: number
}

export function wsClientActionClockUpdate(chainTimestampDelta: number): string {
  const action: WSClientActionClockUpdate = {
    action: WSClientActions.CLOCK_DATA,
    chainTimestampDelta,
  }
  return JSON.stringify(action)
}
